module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-004"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROLOGUE")])])])]), _c('h1', {
    staticClass: "pre_stit"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('span', [_vm._v("Guiding Principles for New Testament"), _c('br'), _vm._v("Theology and Ethics")])])]), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('i', [_vm._v("Let us assume that the notion of a right interpretation of the Bible is not meaningless, but it is eschatological.")])])]), _c('p', {
    staticClass: "auteur"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANS")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REI")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN6",
      "id": "ap_NFIN6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_c('i', [_vm._v("Let us remember that the story is called “Good News.” It is not a rule book. It is not a set of doctrines. It is above all not a ransom note. It is a love letter.")])]), _c('p', {
    staticClass: "auteur"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYNE ")]), _vm._v("A. M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEKS")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN7",
      "id": "ap_NFIN7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("I")]), _vm._v("t has been said that where one starts predetermines where one will end up. I am not totally convinced this is so, but I do think that it would be wise if I lay some of my cards on the table at the outset. I trust that you will find there are no jokers in the deck. A point of departure at the least involves picking a particular trajectory or direction to pursue.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In a small and helpful theological study, Dennis Kinlaw suggests "), _c('i', [_vm._v("Let’s Start with Jesus")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN8",
      "id": "ap_NFIN8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" I like this line of thinking, especially, of course, for Christians, but there are some problems with it. The story of Jesus is the climax of the biblical narrative, neither its beginning nor its end, nor its center."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN9",
      "id": "ap_NFIN9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" From a "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("narratological point of view, it is difficult to start the tale at the climax. It is rather like coming into a movie when it is two-thirds finished. Nevertheless, from a theological and ethical point of view, I think that Kinlaw is quite right. If we are to understand God and the divine blueprint for humankind, we need to begin where the light is brightest and the insights into divine character are clearest.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("This in turn means that the Christian must first learn to read the Bible back to front, so to speak. One needs to know the story of Jesus and the revelation of God in Christ and then read the Old Testament in light of that. This is precisely what we so often find the writers of the New Testament doing. Their experience of and worship of Christ caused a Copernican revolution in their thinking.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Take, for example, the case of Paul. Though as a Pharisee Paul had looked at life through the lens of the Mosaic law, now as a Christian he looks at all things through the eyes of Christ, so to speak. This does not mean that he is leaving behind law or imperatives; it means that he will view God’s law now through his christological lens. Too much of what passes for New Testament theology or New Testament ethics does not in fact start with Jesus, either the person or his words and work. Although New Testament theology and ethics should not be christomonistic (there are other obvious dimensions to these subjects even when examined in a Christian way), they nevertheless should be what the New Testament writers themselves saw theology and ethics to be: christologically focused. This has particular implications for both belief and behavior, and it is the latter that often gets neglected. The call is for the Christian to be Christlike; to follow Christ’s example includes the call to embody the ethic of the Sermon on the Mount, not as just one possible Christian ethical stance but as an essential part of any Christian ethical stance. As we will see, there are some radical consequences to starting the New Testament theological and ethical discussion with Jesus and not with Paul or someone else.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Paradoxically, what this Christian hermeneutical move does not entail, however, is reading the Old Testament in a nonhistorical manner, by which I mean reading it without a sense of the development or progress of revelation through time and the concomitant development of God’s people and their understanding of God over time, and indeed the development of what is called variously the “history of Israel” or “salvation history.” On the one hand, the Old Testament writings can and should be read as the Jewish Scriptures that they are, and they deserve to be heard on their own terms. These ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("books were not written by Christians or, in the first instance, for Christians, although as the New Testament writers were to say later, God had the later Christian audience in view as well from the outset. On the other hand, the very existence of even just the Gospels and their substance, never mind the rest of the New Testament, shows that Jesus and his followers did not believe that the Old Testament was the end of the story or even a self-contained story. It was not viewed from a doctrinal point of view as a closed canon either, with Malachi or some other Old Testament book as the finish line (more on this in a moment). For a Christian to fail to read the Old Testament in the light of the Christ event is to fail to follow the example of the New Testament writers themselves.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("There are other theological and ethical issues that I must introduce before saying more about concepts of progressive revelation and christologically focused readings of the Old Testament. Here it must be stressed that the Christian approach to the Old Testament has to avoid both a Gnostic and a Marcionite approach (treating the Old Testament as if it were pointless or useless for Christian theology and ethics, or as if creation theology and history did not matter much) and also a purely non-Christian interpretation or valorization of the Old Testament while still respecting and learning from Jewish and other forms of non-Christian interpretation of the Old Testament. Much of the Old Testament does not require, and some of it will not submit easily to, a christological reading, and so there must be some care and balance in how a Christian reads the Old Testament, not turning it into some sort of Christian allegory or study of the incarnation before there ever was an incarnation.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN10",
      "id": "ap_NFIN10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" History must be respected, and Christian theology must also be served. One example must suffice here.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As I write this, I am staring at a replica icon, given to me the last time I taught in Moscow, which comes from the very monastery where Rubliev first made the icon of the “Old Testament Trinity.” It is a picture of the three angels who dined with Abraham. In my view, a proper Christian reading of that Old Testament story will say that it is about angels, who represent God, not about members of the Trinity; however, in light of the New Testament, one can talk about that angelophany as perhaps a “foreshadowing” of what is to come. Thus, talking about typology and foreshadowing preserves the historical givenness of the Old Testament while still reading the material in light of its New Testament sequel.")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIVILEGE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTAMENT")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCUMENTS")]), _vm._v("?")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Why narrow ourselves to theology and ethics in and of the New Testament? Why privilege these twenty-seven documents? Fair questions. The first reason is in fact a historical one. All other things being equal, the historian will want to go with the earliest and best evidence about a subject, the evidence that can be traced back to the eyewitnesses or those who knew them. The presumption must be that these witnesses are more likely to know what was going on, what was thought and said, at the beginning of the Jesus movement. And in fact, the earliest documents that we have are those twenty-seven that currently occupy the canon of the New Testament.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("There are only a very few other documents that may be considered first-century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.D.")]), _vm._v(" sources of information about early Christianity: the "), _c('i', [_vm._v("Didache")]), _vm._v(", "), _c('i', [_vm._v("Barnabas")]), _vm._v(", "), _c('i', [_vm._v("1 Clement")]), _vm._v(", possibly "), _c('i', [_vm._v("2 Clement")]), _vm._v(", but probably not the "), _c('i', [_vm._v("Gospel of Thomas")]), _vm._v(". I rule out the "), _c('i', [_vm._v("Gospel of Thomas")]), _vm._v(" for the very good reason that it reflects a knowledge of all four canonical Gospels and their editing and has an ethos and character quite unlike our earlier more Jewish sources. It seems clearly to have been written in the second century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.D.")]), _vm._v(" and probably in the latter part of that century. And although these other first-century documents are very interesting, they are also in various ways derivative. For example, "), _c('i', [_vm._v("1 Clement")]), _vm._v(" is transparently dependent on 1 Corinthians, and the "), _c('i', [_vm._v("Didache")]), _vm._v(" reflects material that we find in the Gospel of Matthew. Even on the showing of the Jesus Seminar, the "), _c('i', [_vm._v("Gospel of Thomas")]), _vm._v(" perhaps provides us with one or two more otherwise unknown sayings of Jesus, but they add nothing of significance to our understanding of Jesus that we could not have derived from the earlier Gospel material. On the whole, it is fair to say that we learn little from these documents that is new about first-century Christian theology or ethics.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("And, of course, besides this historical judgment about our earliest and best sources, there is also the fact that the early church of the fourth century, both east and west, concurred on these twenty-seven books being Scripture. This was a theological judgment as much as it was a historical one, as it was decided that these twenty-seven documents were normative and authoritative witnesses to the gospel truth and the apostolic evidence, suitable for use in faith and practice and particularly in worship, including in the teaching and preaching of Christian theology and ethics. These reasons are sufficient rationale, in my view, for concentrating on these books and not on others. They are our earliest, best, and most clearly sanctioned witnesses to early Christian belief and behav")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("ior. Thus, this study limits itself to what we find in the New Testament. That is more than enough of a landscape to peruse in one foray.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN11",
      "id": "ap_NFIN11-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVINE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVELATION")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN")]), _c('br'), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTAMENT")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEOLOGY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THICS")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Another of my assumptions is that the Bible is both the words of human beings and, in and through those words, the living Word of God. To me, it seems impossible to deal with a subject such as New Testament theology or New Testament ethics without being clear about the concept of divine revelation. If one denies that revelation from God is even possible, then it is understandable that one will be uncomfortable with talking about “the theology” or “the ethics” of the New Testament. After all, there are a variety of human authors and editors of the material in the New Testament, and one cannot expect all of them simply to agree as if by magic, especially when many of them wrote while being quite unaware of what other New Testament writers were saying or would say about a variety of topics. It is the presumption of a divine mind behind and speaking to and through all the human minds reflected in the New Testament that makes a topic such as New Testament theology or New Testament ethics a viable possibility.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("If you are a student of church history, you will have noticed how often strong disagreements and flat contradictions have characterized that history. If the New Testament were just another church document, we would expect it to mirror these same sorts of flaws, but in fact it reflects a remarkable degree of harmony and unity throughout, in both its theologizing and its ethicizing. For example, we do not find one New Testament book arguing the case against Jesus being the divine Son of God while others argue for it. We do not find one New Testament book arguing that holy behavior is optional for Christians while others argue that it is mandatory. If all Scripture, including the New Testament books, is indeed God-breathed, then we may anticipate there being some sort of unity without uniformity in the New Testament literature, and in fact there is such a unity in the midst of diversity and difference.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I have stressed in "), _c('i', [_vm._v("The Living Word of God")]), _vm._v(" that if we take an inductive approach to the issue of what the phrase “the Word of God” means in various "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("New Testament witnesses, and take an inductive approach to what inspiration amounts to and looks like, we will come to the conclusion that various New Testament writers believed that they spoke and wrote not just their own words but indeed the Word of God under the inspiration of the Holy Spirit. But what inspiration actually looks like is what we find in the New Testament itself. This means that preconceived ideas about how the Word of God or “truth” can or should be expressed must be jettisoned in favor of a detailed examination of how it actually has been expressed in various genres of literature and in various forms of discourse in the New Testament.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN12",
      "id": "ap_NFIN12-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The Word of God that we have may not be the form of the Word of God we might want, since it has many peculiar features, including varying testimonies to the same events, and is often general when we would like it to be specific and vice versa. But we have what we have. Furthermore, it is not merely a bunch of eternal principles that are to be ferreted out of a mass of cultural forms of expression. It will not do to take a Docetic approach to the Bible. Rather, we must recognize the incarnational form of God’s revelation as it has come in a particular language at a particular time in particular forms of expression to particular first-century authors and audiences. The text of the New Testament does not have a meaning apart from its particularity; it has a meaning in its particularity. This is what we should expect, since God came in person into human history in Christ. An incarnational God quite naturally is witnessed to by an incarnational text, full of historical particularities. This is one reason why I will not be talking about the theology or ethics "), _c('i', [_vm._v("of the New Testament ")]), _vm._v("in this first volume but rather about the theologizing and ethicizing of particular New Testament writers. And as my colleague Amy-Jill Levine reminded me, the New Testament authors are writing to followers of Jesus, who need to hear particular aspects of the “good news.” Thus, there is a praxis-oriented and person-oriented aspect to the study; the theologizing and ethicizing do not follow a “one size fits all” model, since human beings are not all the same. We all have different needs, gifts, and talents.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROBLEMS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WITH")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EADER")]), _vm._v("-R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESPONSE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITICISM")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANONICAL")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERPRETATION")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I have come to the conclusion that there is no such thing as “the autonomy of the text,” despite many protests to the contrary in our era. Furthermore, "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("reader-response criticism of the New Testament has, frankly, led people astray about the nature of meaning and how it works in New Testament texts. In fact, only in a literate, text-bound Internet age such as ours would a thesis about the autonomy of texts or about meaning residing in the eyes of the avid reader even be possible. But it is quite impossible as a way of looking at the New Testament when one realizes that the New Testament texts are just parts of, or surrogates for, the oral speech of specific individuals such as Paul and Peter. Although it is impossible to become mind readers or channelers of the minds of deceased New Testament writers, we may speak of the New Testament texts as expressing a portion of the thoughts and meanings of various New Testament writers. The fact that we are active readers requires that we be aware and also wary of this fact lest the text be read anachronistically over and over again. We must show respect for the original historical authors and the meanings that they encoded into their words and sentences and discourses and seek first to understand what they wrote on their terms, not ours. This, of course, requires actual historical study of the biblical text. This is not an optional extra feature added to understanding the New Testament; it is essential to the study of the New Testament. Not even New Testament theology or ethics should be studied in a nonhistorical manner.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("The New Testament texts are extensions and expressions of the historical persons who wrote them. They did not exist in isolation when they were written, and they do not exist in isolation today. They were only part of an ongoing conversation and communion between believers then, and they are so today as well.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN13",
      "id": "ap_NFIN13-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" By this I mean that we have more than literary evidence about the past. We also have material and cultural evidence through the hard work of archaeologists and historians. Of course, we also have some of the authors’ source material, namely, the Old Testament! What we do not have in the New Testament is a sense of canon, if we are referring to the New Testament writings themselves, except perhaps in 2 Peter 3. There, Paul’s letters are ranked along side “the other Scriptures” (2 Pet 3:16). Thus we do begin to see the process of canonization already during the New Testament period.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("And this very historical perspective is one reason why we cannot, in the same breath, speak about the theologizing and ethicizing going on in the New Testament and canonical theology or canonical criticism. There was no "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("New Testament canon during the New Testament period, and it is not the later fact of the existence of a canon that shapes this material or determines its theological or ethical contours. Canonical theology is an "), _c('i', [_vm._v("ex post facto ")]), _vm._v("thing that by definition could not exist in any full sense before the fourth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.D.")]), _vm._v(" if we are including the New Testament canon in the discussion. In other words, the theology and ethics within the New Testament is one thing, but canonical theology is something else.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("It is not the canonizing of this material in the first instance that gives it authority or normativity in the church. It already had that before there was a canon for the very good reason that it was apostolic testimony that spoke the truth about Jesus and other subjects important to early Christians. It is the truthful and apostolic character that gave these documents authority, not the church’s later valorization of these books, though that valorization did accelerate the process of their acceptance and recognition, even including disputed books such as 2 Peter and Jude. And just as it is not the canonizing of these documents that gave them authority in the first instance, so also it is not the “church” that gave them authority in the first instance.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("We need to be as wary of an ecclesiocentric approach to New Testament theology and ethics as we need to be wary of a canonical one if our goal is to understand this material in its original, first-century contexts. The question to be asked is “Why were these documents deemed authoritative and normative in the very era in which they were written, the first century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.D.")]), _vm._v("?” Clearly, it is not because they were already part of a collection of books called “the New Testament”! This means that they must have been viewed as having some sort of inherent authority, not an authority derived from later church councils or evaluations. This inherent authority has to do with their apostolic truth content. At this juncture, it will be good to have a brief dialogue with Francis Watson’s discussions about these very matters.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELATION")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLICAL")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEOLOGY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TO")]), _c('br'), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTAMENT")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEOLOGY")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("It is one of the fundamental assumptions of this entire study that what is historically false cannot possibly be theologically true, when a theological assertion is being made about something historical. As applied to this study, what I mean, for instance, is that books written by Jews for Jews, not in the first instance for Christians, who did not yet exist, cannot lead to the conclusion that the Old Testament is simply a Christian book and its truth can be properly ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("understood or interpreted only by faithful Christians. This whole approach to the matter seems to me to entail a fundamental denial of the very nature of God’s revelation and its progressive character, and furthermore a denial that the biblical message is not merely for the found but also for the lost. A theology of revelation or canon or of the Spirit that involves ignoring the historical facts or, worse, denying them is not a proper biblical theology at all.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Francis Watson, in his stimulating study "), _c('i', [_vm._v("Text and Truth: Redefining Biblical Theology")]), _vm._v(", insists that the “Spirit of truth bears witness to the grace and truth that are to be found in the enfleshed Word not directly but "), _c('i', [_vm._v("in and through the Christian community—in and through its preaching and worship, its sacraments and canonical texts. These texts are foundational to the life of the church, not on the legalistic and biblicistic grounds that they possess an inherent, absolute authority to which we are bound to submit, but on the grounds that in them we encounter the particular life upon which the communal life of the church is founded: the life that is the light not only of the church but of the world")]), _vm._v(".”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN14",
      "id": "ap_NFIN14-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In this view, apparently, the Spirit did not show up on planet earth prior to or outside the context of the church. There was no direct encounter between God and his chosen people, the Jews, prior to the coming of Christ and the Spirit to the followers of Jesus. I would not want to deny that the church is one place where God reveals his truth through his Word, but surely it is not the only place; otherwise, evangelistic preaching in a place where there is no church would be nothing more than words full of sound and fury but accomplishing nothing. There is a further problem with Watson’s argument."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN15",
      "id": "ap_NFIN15-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" The Bible does indeed have an inherent authority precisely because it tells the truth about the matters that it discourses on. It does not merely have an authority because in it we encounter the Life, the Lord, about which it speaks, though of course that is true as well.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Another difficulty with Watson’s approach has to do with making “texts” prior to almost all else. Watson says, “The Word made flesh is never encountered without textual mediation, for Jesus is only recognized as such on the basis of a prior textuality. Jesus is initially acknowledged as Christ and Lord because that which takes place in him is said to take place ‘according to the scriptures.’”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN16",
      "id": "ap_NFIN16-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" While I quite agree that “the life of Jesus did not take place in "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("a text-free vacuum,”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN17",
      "id": "ap_NFIN17-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" I would note that it did take place in what was largely an oral culture, not a culture of texts. Furthermore, prior understanding of at least some of the Bible does not seem to have been a prerequisite for grasping at least some of the meaning of the Christ event or for having an encounter with Jesus in the first generations of Christians.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("There were, undoubtedly, some who encountered Jesus without prior knowledge of the Hebrew Scriptures, and some of them indeed became his supporters, his partisans, his followers. One cannot well imagine the Gadarene demoniac as a student of the Hebrew Scriptures who understood Jesus on the basis of prior textual knowledge. Quite the opposite, it was the encounter with Jesus that led various people into a proper relationship with the text of the Scriptures. There were both mediated and unmediated encounters with Jesus, just as there have always been both mediated and textually unmediated encounters with the Holy Spirit and God the Father as well. It is one thing to say that Jesus, God the Father, and the Spirit cannot be fully understood without an understanding of the Scriptures; it is quite another to suggest that the church has a monopoly on the truth or on the encounter with and grace of God, or that it can only happen in the context of Christian community, worship, and the sharing of Christian texts. One can only wonder what the Moslem “followers of Issah” in various Moslem countries, who have become such because of visions that they have had of Jesus but who previously had never read the Bible or been part of a church, would think about such assertions. I am confident that they would find something terribly wrong with such notions.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("On the other hand, Watson is right that the text of both Testaments, Old and New, are needful if one is to understand the full scope and meaning of the revelation of God in Jesus Christ. On this basis, Watson goes on to insist that “all Christian theology must be biblical theology.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN18",
      "id": "ap_NFIN18-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" I would agree with this assertion if by it one means that New Testament theology is founded and grounded in the Hebrew Scriptures and is dependent on them as a revelatory source in various ways. New Testament theology cannot stand alone, nor should Christian interpreters become the followers of Marcion.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This fact, however, does not make the Hebrew Scriptures in the first instance “the church’s book,” nor does it mean that we may expect to find full-blown Christian theology in the Old Testament—for instance, a doctrine "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("of the Trinity or a doctrine of salvation by grace through faith in Jesus. It is precisely the historical realities reflected in the Old Testament that rule out such a theological approach. Christian theology that draws on the Old Testament cannot be done in some sort of ahistorical or flat way that does not take into account the progressive revelation of God and the fundamentally pre- or non-Christian character of the Old Testament. The attempt to turn the Old Testament into a Christian allegory involves a failure to grasp the historical nettle and is, at the end of the day, a bad example of historical anachronism. This does not mean that the Old Testament cannot be used in various Christian ways. It can. But that is more a matter of homiletical use and application than of interpretation of the Old Testament.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("The Old Testament is primarily about the revelation of Yahweh, the one whom Christians call “God the Father,” and only in a secondary sense, and by way of promise and prophecy, a revelation of the Son and the Spirit. If the actual theological substance of the Old Testament is taken into account, and not merely its contemporizing hermeneutical use by later Christians, then it is in fact possible to say that what we have in the Old Testament is truths that could equally well be affirmed by Jews, Christians, and Moslems, and indeed they are affirmed by various such believers, though the uses that they make of these texts vary. The fact that these Old Testament truths may not be sufficient in themselves unto Christian conversion or salvation is another matter. Truth is no less true simply because it is, as the author of Hebrews 1:1 suggested, “partial and piecemeal.”")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('i', [_vm._v("It is crucial to keep steadily in view both the historical givenness of the biblical texts and their theological character. They always and everywhere speak about a God who reveals himself in space and time in various ways to various persons, both saved and lost, both Jew and Gentile, both literate and illiterate, both textually aware and textually oblivious. Abraham did not encounter and follow God’s directives on the basis of a prior understanding of Holy Writ mediated to him through a community of faithful interpreters of the Genesis sagas.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("I quite agree with Watson, however, that the Bible is irremediably theological in character. It is all about God and God’s relationship with various human individuals and groups. The Bible’s history cannot be readily abstracted from its theologizing or vice versa. There is, of course, a good reason for this: God is committed to involvement in the messiness and contingencies of human history and always has been. Indeed, it should be said that God, as the creator of all things, including all human beings, is the one who made ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r36"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("history possible, viable, having purpose and goal, and so on. Further, I agree with Watson that the segregation of biblical studies from theological studies has led to the impoverishment of both fields. Exegetes are working on inherently theological texts! Biblical theologians require exegetical study to come to grips with the subjects of their own fields of interest and inquiry. Watson is right to complain about the rigid divisions of these fields in the guild.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Watson urges a “dialectical” interdependence between the Old Testament and the New Testament, decrying the tendency to see the Old Testament as merely background for the New Testament. He urges, “The notion of a dialectical unity between the two bodies of writing, constituted as ‘old’ and ‘new’ by their relationship to the foundational event that they together enclose and attest, only makes sense from a theological standpoint.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN19",
      "id": "ap_NFIN19-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" I agree with this assertion in principle, but I would add that such an assertion only makes sense from an historical viewpoint as well. After all, the terms "), _c('i', [_vm._v("old")]), _vm._v(" and "), _c('i', [_vm._v("new")]), _vm._v(" refer to time and space and to events that happen in time and space and objects that are created in time and space, such as the various parts of the Bible. Watson later rightly stresses that the biblical texts are both theologically motivated and genuinely historiographical in intent and character."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN20",
      "id": "ap_NFIN20-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Here is where I must insist, however, that unless one does justice to both the historical and theological character of these texts, one will neither be doing theology properly nor be doing history justice. What do I mean by this? For one thing, I mean that the Old Testament does not cease to be Christian Scripture simply because it mostly tells us about God the Father and his relationship with the universe, the world, a people. Patrology (the study of God the Father), in the more antique and theologically loaded sense of that term, is just as much a part of Christian theology as Christology is. The fact that with benefit of hindsight and further revelation Christians came to view the Father through the lens of the Son and the Spirit does not mean that we cannot appreciate what is going on in the Old Testament on its own terms and, furthermore, recognize that the Christian doctrine of God would be severely and seriously impoverished without what the Old Testament has to say about that matter and many others. For example, the holiness, justice, mercy, and indeed the love of God would be far less clear if we did not have the Hebrew Scriptures.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r37"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("Watson is calling scholars to practice “biblical theology.” He defines it as follows: “Biblical theology is "), _c('i', [_vm._v("biblical")]), _vm._v(", that is, concerned with the whole Christian Bible; it is more than the sum of Old Testament theology and New Testament theology, understood as separate disciplines. Biblical theology is "), _c('i', [_vm._v("theology, ")]), _vm._v("where attempts are made to limit it to a purely descriptive capacity, it quickly becomes redundant and the expression passes out of use.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN21",
      "id": "ap_NFIN21-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" I am in sympathy with the thrust of both of these sentences, but some qualifications are needed.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("First, although biblical theology may be more than the sum of Old Testament and New Testament theology, if it is truly “biblical” theology, it cannot be other than Old Testament and New Testament theology lest it cease to be biblical in the proper sense. By this I mean that biblical theology can be constructed only out of Old Testament and New Testament theology and theological material. It has no other primary resource. And when it goes beyond what is said in the Old Testament and/or New Testament, it has to be ever so careful not to go against what is said in those sources. I do not think that biblical theology can or should be attempted without reliance on both Old Testament and New Testament theology and on the work of those scholars who labored long in the vineyard of Old Testament or New Testament theology. This includes reliance on the work of various non-Christian scholars, and it means indeed that the attempt to build or frame a biblical theology cannot be seen as a task that involves only reliance on or dialogue with Christian interpreters. In other words, a hermeneutical ecclesiological a priori is a mistake when one is attempting to do a biblical theology worth its salt and open to all insights from whatever sources and scholars."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN22",
      "id": "ap_NFIN22-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Second, I must insist that the proper order of things is that discovering and discerning the character of Old Testament theology and New Testament theology on its own merits must be seen as a necessarily prior enterprise to the constructing of a biblical theology, not least because we have all seen what happens when the Bible is read through the grid of later Calvinist or Arminian or Lutheran or Orthodox or Catholic systematic theology: the biblical text is read anachronistically and is gerrymandered for various later theological purposes and battles of which the biblical writers were innocent and ig"), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("norant. In short, distortion of the meaning of biblical texts happens over and over again as the attempt is made to make them fit a preexisting theological schema. A good example of this is the rapture doctrine that underpins dispensational theology, a doctrine that the church had never heard of or really believed in before the nineteenth century.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN23",
      "id": "ap_NFIN23-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("And then there is the further problem that when one begins talking about the “Christian Bible,” one must ask, “Which one?” Would that be the Bible of the Orthodox or the Catholics or the Protestants? What counts as foundational texts, and are any beyond the generally received sixty-six books legitimate as sources for Biblical theology? But when you ask about which Christian Bible, you have asked not merely a theological question but also a historical one.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I, as a New Testament scholar, do not feel competent to do “biblical theology,” and, frankly, I know few people who are competent to do so, whether exegetes or theologians, for this requires a level of knowledge and expertise not only in the Old Testament and New Testament but also in the larger sphere of theology. I suspect that such a project would require a variety of Old Testament and New Testament scholars and theologians working together. However, I do feel competent to talk about the influence of the Old Testament on New Testament thought, on the use of the Old Testament in the New Testament, on the grounding of much of New Testament thought in Old Testament thought, and the like without ignoring the paradigm shift that comes as a result of the Christ event. From a hermeneutical point of view, since Christians are not under the old covenant in any of its manifestations, how exactly the Old Testament is the basis of Christian theologizing is a delicate question in various regards, and it is insufficient to say that the Old Testament must simply be read christologically, though that is one of the tasks that the New Testament writers themselves undertake and encourage us to undertake.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROBLEMS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WITH")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSTMODERN")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERPRETATION")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("More helpful are Watson’s trenchant criticisms of postmodern and reader-response approaches to the biblical text. He throws down the gauntlet at the beginning of his essay on this subject:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant last"
  }, [_vm._v("A Christian faith concerned to retain its own coherence cannot for a moment accept that the biblical texts (individually and as a whole) lack a single determinant meaning, that their meanings are created by their readers, or "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r39"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("that theological interpretations ["), _c('i', [_vm._v("sic")]), _vm._v("—surely he means “interpreters”] must see themselves as non-privileged participants in an open-ended, pluralistic conversation. Such a hermeneutic assumes that these texts are like any other “classic” texts: self-contained artifacts, handed down to us through the somewhat haphazard processes of tradition, bearing with them a cultural authority that has now lost much of its normative force, yet challenging the interpreter to help ensure that they will at least remain readable, and continue to be read.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN24",
      "id": "ap_NFIN24-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Watson is right to assert that an author’s meaning is encoded into the words that convey it and that we can know something of the author’s intention in saying such things by studying the author’s words in their original context. Writings, perhaps inspired writings in particular, have the intention of communicating something of importance to one or more recipients. Watson puts it this way: “When A speaks to B about x, what B receives is not a communication about x that might have come from anywhere . . . but a communication that is distinctively A’s communication. To understand and to respond to the communication is therefore not only to understand and respond to what is said about x but to understand and respond to A. Communication is an irreducibly "), _c('i', [_vm._v("interpersonal ")]), _vm._v("event.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN25",
      "id": "ap_NFIN25-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This is right on target. If one properly understands a text, then one has understood what the author intended to say and does say. The text cannot be severed from its original author, since it is an expression of the mind of that author, nor can or should it be assumed that the meaning of the text is to be generated by the receiver of the communication. “Verbal meaning is not so ephemeral. . . . Readers can only receive meaning, they cannot "), _c('i', [_vm._v("create ")]), _vm._v("it.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN26",
      "id": "ap_NFIN26-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Can there be a secondary significance to a text not originally intended by the author? Well, yes, that is possible, but, as Watson goes on to stress, “true ‘significance’ is to be found "), _c('i', [_vm._v("in the single, verbal meaning itself")]), _vm._v(", that is in its enduring . . . force. The notion of a secondary, ephemeral ‘contextual significance’ is therefore subordinate to the primary universal significance this text claims by virtue of its role as ‘gospel.’”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN27",
      "id": "ap_NFIN27-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Here I prefer to substitute “Word of God” for “gospel.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Equally helpful is Watson’s stress that the biblical author is concerned not merely that the audience understand, but that they act. There is, of course, a distinction between understanding a communication and choosing to re"), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r40"
    }
  }), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("spond appropriately to it. “An adequate interpretation of the literal sense of a text will seek to explain not only what the author is "), _c('i', [_vm._v("saying")]), _vm._v(" but also what he or she is "), _c('i', [_vm._v("doing")]), _vm._v(".” Watson reminds us that even with lack of clear understanding of what an author or speaker is saying, we may still know what that author wants, precisely because of the context. Watson gives the example of encountering a border guard speaking in a foreign language that one does not know. One correctly surmises that the guard is performing a speech-act, wanting the listener to produce his or her passport. Even though the listener has failed to understand the meaning of most or all of the speaker’s words, the speech-act is successful because the context made clear what the speaker wanted.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN28",
      "id": "ap_NFIN28-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Watson goes on to stress that normally speech-acts require a certain context if they are to achieve their intended effect: “To make a promise or issue a command presupposes a complex set of prior conditions and relationships”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN29",
      "id": "ap_NFIN29-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" This is true, but only up to a point, or else a speech-act could never communicate successfully with a stranger or a foreigner unaware of the author’s context and not sharing that author’s community. Evangelism would be impossible if one takes too narrow a view of what preconditions are required for genuine communication.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Watson is, however, quite right that the intention of the author should not be divided from the text of the author, as if intent lies only in the mind of the speaker or writer and the words are something else. He rightly warns, “It misunderstands authorial intention as a purely psychological event that precedes and constrains the words, exerting a continuing influence on the text from the outside. Against this view, authorial intention is to be seen as primarily embodied in the words the author wrote.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN30",
      "id": "ap_NFIN30-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" “Authorial intention is the principle of a text’s intelligibility, and cannot be detached from the text itself. The capacity of writing to extend the scope of a speech-act in space and time precludes an understanding of authorial intention purely in terms of the author’s immediate historical context.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN31",
      "id": "ap_NFIN31-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" But it is not just the capacity of writing that does this, for we are dealing with the living Word of God, "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r41"
    }
  }), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("not just any kind of communication. We are dealing with words that God uses repeatedly to convey not merely his meaning but also his presence, his salvation, and many other things. Much of the discussion in this particular section prepares us for the next section, which deals with the issue of context.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-008"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MPORTANCE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGINAL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTEXT")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("I tell my students all the time that a text without a context is just a pretext for what we want it to mean, and thus the New Testament text must be read in its historical, rhetorical, literary, social, and religious contexts. This is just as true of the theologizing and ethicizing of the New Testament writers as anything else. Texts themselves do not theologize or ethicize into various contexts, people do. We can talk about the theologizing or ethicizing of Paul or Peter, but we cannot talk about the theologizing or ethicizing of 1 Corinthians, for instance. Talk of the theology or ethics of this or that book is just one more attempt to abstract the theology from its human and personal and historical context so that it can be manipulated, and this is a mistake. The texts come from real human beings in real situations that we, through various forms of contextual study, know a good deal about. These texts do not have meaning, or at least their meaning cannot be fully understood, apart from a knowledge of these linguistic, cultural, social, rhetorical, historical, and religious contexts.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("For example, I will not understand what Jesus meant in Mark 10:45 about being a ransom in place of the many unless I understand something about processes of redemption out of slavery and bondage in the first century, something about early Jewish thinking about death as a means of atonement, and something about the echoes of Isaiah 53 in this verse—to present only a brief list of things needful for understanding. Unless we read texts in their original historical contexts, there is the ever-present danger of anachronism and distortion. In other words, Christian theologians need to care about history and its contexts because the New Testament is not composed of abstract philosophizing about Jesus or the Christ event. They need to stop talking about the autonomy of texts altogether if the New Testament is their point of reference. It is also not all that helpful to start by reading the New Testament in light of later philosophically grounded theological debates that resulted in the creeds of the third and fourth century and later. Rather, we must pay it forward. The creeds should be read in the light of the New Testament and critiqued by the New Testament. In fact, all later biblical, historical, system")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r42"
    }
  }), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("atic, or modern special interest theologies (e.g., postcolonial readings or radical feminist readings) need to be normed by and critically sifted in the light of what the New Testament actually says and means, if we are interested in doing Christian theologizing or ethicizing.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-009"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROBLEMS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WITH")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTENTIONAL")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLACY")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEORY")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("An equally egregious mistake often made today is talking about the “intentional fallacy.” As Philip Esler has recently stressed in his groundbreaking work "), _c('i', [_vm._v("New Testament Theology: Communion and Community")]), _vm._v(",")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN32",
      "id": "ap_NFIN32-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" William Kurtz Wimsatt and Monroe Beardsley, who coined the phrase and wrote the original essay about “the intentional fallacy” (published in 1946), were talking about only one kind of literary text—poems! It is about poems that they said, “The design or intention of the author is neither available nor desirable as a standard of judging the success of a work of literary art.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN33",
      "id": "ap_NFIN33-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" In their view, poems existed in a highly unusual world of signification divorced from both intentionality and meaning. Wimsatt and Beardsley go on to make the following important distinction: “In this respect poetry differs from practical messages, which are successful if and only if we correctly infer the intention.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN34",
      "id": "ap_NFIN34-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" In other words, since the New Testament is not simply a bunch of poems, even the original authors of the “intentional fallacy” idea would not see it as applicable to the New Testament!"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN35",
      "id": "ap_NFIN35-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As Esler stresses, what we have in the New Testament are very definitely practical messages that presuppose historical authors and audiences that have a relationship, even in the case of an anonymous document such as Hebrews or 1 John (see, e.g., Heb 13). Therefore, it is important to interpret New Testament texts in light of all the available contextual evidence that we have, and we must assume that these texts express some of the mind and intentions of their historical authors.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We must also assume that these texts were intended to have, and do have, meanings. Meaning is encoded in the text; it is not something readers should feel free to construct for themselves, though of course it is true that active readers do often read things into the text of the New Testament that simply are not there. We would call that a “bad reading” of the text. My theory of "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r43"
    }
  }), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("meaning is derived from the work of people such as E. D. Hirsch and, more recently, Kevin Vanhoozer, and as a historian, I must say that their epistemology and theories of meaning seem much closer to that of the New Testament authors than do those of modern scholars who are more indebted to existentialist and nihilist philosophers than they are to the biblical sources when it comes to the matter of meaning.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN36",
      "id": "ap_NFIN36-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" Words have meaning in contexts, and the context is not just literary in the case of the New Testament documents; it is the rhetorical environment of oral discourse, declaration, proclamation, and persuasion. The more we know about how words worked in an oral culture, the better we will understand the theologizing and ethicizing of the New Testament.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I would also make a distinction between the meaning of a text and its larger significance for later readers. A text can have all sorts of personal significances for various people that are not necessarily directly derived from the original intended meaning of the text. For example, when our first child was about to be born, my wife and I were reading Ezekiel, in its latter chapters, and we heard God’s promises to Israel to multiply their kindred, keep them safe, and bring them home soon. Of course, I knew that these were promises to exilic Israel about their return to the Holy Land. But God used those words to speak to my wife and me, and sure enough, our first child was born safely the next morning, and they came home from the hospital soon thereafter. That is an application to a different audience in different circumstances, but the promise was just as significant to us.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-010"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EANING")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTAMENT")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EXTS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEIR")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGNIFICANCE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FOR")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODAY")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In a seminal essay written in the 1960s, Harvard professor Krister Stendahl made a distinction between what a text meant and what it means today. I am not entirely happy with this distinction. I would prefer to talk about the difference between what it meant and what it may signify for various people today. I prefer to say that what it meant back then and there is still what the text means today. The meaning has not changed, though the implications, applications, and significances do change as the world and its cultures change.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r44"
    }
  }), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("Stendahl admits in his discussion that the reason behind the distinction between what it meant and what it means is his distaste for, and desire to distance himself from, the original meaning, or at least from the history-of-religions findings about the original meanings of these New Testament texts. What especially disturbed scholars such as Rudolf Bultmann, Karl Barth, and Oscar Cullmann was the disregard for both the theological substance of the New Testament documents and the discounting of their relevance for current thinking, believing, and behaving. It was in response to the history-of-religions approach that what came to be called the “biblical theology movement” arose, but with a price. Stendahl notes, “The biblical theologian becomes primarily concerned with the present meaning, he implicitly (Barth) or explicitly (Bultmann) loses his enthusiasm or ultimate respect for the descriptive task.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN37",
      "id": "ap_NFIN37-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" On the one hand, this sort of assumption led a figure such as Bultmann to insist on the demythologizing of the text, and on the other hand, to look for a contemporary form of thinking, in this case existentialism, to serve as the new language through which to express theology and interpret the New Testament. There were problems with both ends of this project. Barth, for his part, took more of an ahistorical approach to the theology of the New Testament without endorsing existentialism as the vehicle that provides the hermeneutics or language of proper discourse.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Why is it important to take the stand that what the text meant then is still what it means today? The answer is simple. If the New Testament is indeed the Word of God, then we must work especially hard to respect its historical givenness and incarnational quality. We must do our homework and do our best to understand the inspired words in their original form and settings. Put another way, these words were the Word of God for first-century persons. They had to make some sense to them as they originally addressed those audiences. And they will make sense to us the more we enter into their thought world, the more we understand their forms of discourse.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The negative corollary of this is that what these words could not possibly have meant in the first century they cannot mean today, even when it comes to prophetic material, as we will see. A good example of the problem is shown by Augustine’s famous allegorizing of the parable of the good Samaritan, in which he argues that the Samaritan is Jesus, the oil and wine are the sacraments, the inn is the church, and the money is penance money. It is safe "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r45"
    }
  }), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("to say that Jesus’ original audience could never have understood this parable that way, nor did Jesus himself. New Testament theology is not properly done if it discounts or ignores or downplays the historical character and substance of the New Testament documents. As Stendahl puts it, we need a “theology which retains history as a theologically charged category.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN38",
      "id": "ap_NFIN38-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("New Testament theology or ethics is also not properly done if we simply assume that our modern worldview and presuppositions are obviously better and more correct than those of the authors of the New Testament itself. Actually, we most often see this latter assumption in play when it comes to New Testament ethics. For example, we will hear things such as “The New Testament writers accepted and even endorsed slavery, which we know now is obviously wrong, and therefore we cannot simply accept and apply the ethical imperatives of the New Testament today.” Such judgments then give permission to take a “pick and choose” approach to both New Testament theology and New Testament ethics, and the basis of such choosing is usually certain unproven and unexamined modern assumptions. There are numerous problems with this whole approach.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In the first place, it involves a failure to do one’s historical homework adequately. The New Testament writers no more endorse slavery than they endorse ancient patriarchy. Rather, they must begin their discourse on such subjects where the audience actually is and try to mold a more Christian approach to existing institutions. Close examination of what the New Testament says on both these subjects shows the New Testament writer prodding and leading their audiences to question the zeitgeist in regard to these issues and move beyond such fallen views and institutions. So, for instance, in Philemon, Philemon is exhorted to treat Onesimus no longer as a slave but rather as one who is much more than a slave, as a brother in Christ. Similarly, in Ephesians 5, Paul offers, as a heading for his discussion of submission, respect, and love in the family, an exhortation that all Christians submit to one another out of reverence for Christ (Eph 5:21).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In other words, a superficial reading of the historical evidence has led to the conclusion that at least some of the New Testament evidence is morally and even theologically repugnant and thus needs to be replaced by more modern ideas. I do not agree with this assumption, which takes as its premise, “We know better than they did what is theologically and ethically right.” I do not think that modern human beings, who allow atrocities such as the "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r46"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("genocides of the Holocaust and Darfur or other enormous ethical lapses to happen, are in a position to lecture ancients about their ethics or theology.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("In the second place, we need to bear in mind that just because a remark is a word on target for a first-century audience, and so historically and culturally conditioned, it does not follow from this fact that it is historically and culturally bound. If there is one thing that the Bible has demonstrated over and over again, it is its ability to cross time and cultural barriers and be a living Word of God in settings and eras very different from the original ones. This is not because the Word has been or needs to be transformed to suit the different or later audience and its predilections; rather, it is so because the living Word has simply been translated adequately and accurately for a different time and place and applied in a culturally sensitive manner. The Word is eternally relevant as it is; it does not, in our desperate quest for “relevance,” need to be transformed into something that it was not, nor does it need to be “made relevant” for today. It is rather we who, and our cultures that, need to be transformed in the image of the Word. It is, however, a necessary part of any good Christian communication to be able to show the meaning, importance, and relevance of the text of Scripture. A good motto to follow is that of Johannes Bengel: “Apply the whole of yourself to the text, apply the whole of the text to yourself.”")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-011"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELATION")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTAMENT")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEOLOGY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THICS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TO")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATER")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEOLOGICAL")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THICAL")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORMULATIONS")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("The historical approach taken here, unlike a canonical one or a “biblical theology” approach, leads to other important insights as well. Take, for instance, the use of God language ("), _c('i', [_vm._v("theos")]), _vm._v(") in the New Testament. In all but seven places in the New Testament the term "), _c('i', [_vm._v("theos")]), _vm._v(" refers to the one whom Jews knew as their God and earliest Christians called “Father” or “Abba.” In those other seven instances the term refers to Jesus, God’s Son. The term never refers to the Trinity in the New Testament, though I would argue (and I will do so in volume 2 of this study) that the raw materials of later trinitarian doctrine and the beginnings of trinitarian thinking are already in evidence in the New Testament itself. The idea of God being tripersonal begins to be expressed in places such as Matthew 28:18-20, but this nodal idea was to be developed over time and after the time of the New Testament writers.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("We may talk about trajectories of ideas and understandings that are further developed beyond what the New Testament says in the succeeding centu")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r47"
    }
  }), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("ries, but when this is done faithfully, it is consonant with the earlier source material and moving in the same direction. But we do not find in the New Testament itself the Chalcedonian formula, or even the earlier Nicene Christology in toto for that matter, and in fact some of the things said about God in those later formulae do not comport with some of the things said in the New Testament itself about God (e.g., about the apparently impassable nature of God). Much less do we find later Protestant or Catholic Reformation theology in the New Testament.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("If evaluated anachronistically based on the later standards of creedal orthodoxy (much less confessional orthodoxy or canon law or even modern notions of orthodox Christianity of whatever stripe), New Testament theology, like New Testament ethics, is not a completely finished product. We can talk about normative beliefs and ethical standards in the New Testament, but we cannot talk about New Testament dogma. This is why I think that a historical approach to this material requires that we speak about the theologizing and ethicizing into particular contexts in the New Testament. All of this is by way of reminding my readers that they may well find that what is said about New Testament theology and ethics in these volumes does not answer all the pertinent questions that they might have on the basis of later standards and understandings of what Christian belief and behavior ought to look like. There is an apparent incompleteness to the New Testament when it comes to our interests in things such as trinitarian theology and modern medical ethical discussions, though I would urge that the New Testament has some valuable things to say that aid and should inform those discussions. Indeed, I would say that the New Testament provides us with the sort of theological and ethical vision out of which we can wisely address such issues.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-012"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MPORTANCE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENRE")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("A further assumption with which I am operating is that understanding the genre of a particular New Testament document is a key to being able to understand its meaning. The genre conventions followed in the New Testament are ancient, not modern. Matthew, Mark, and John reflect the conventions of ancient biographies, while Luke-Acts reflects the conventions of ancient Hellenistic historiography. In addition, there are in the New Testament ancient letters, sermons, rhetorical discourses, and apocalyptic prophecy, each of which has its own genre signals and distinctives. It is quite impossible to ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r48"
    }
  }), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("ferret out the meaning of this or that text while ignoring the genre signals in these various documents. Such a procedure, which all too often happens when one takes a “purely theological” or a “purely ethical” approach to the New Testament data while ignoring the historical issues, leads to misunderstanding and to misinterpretation of various sorts.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("What we should deduce from this previous paragraph is that there is something fundamentally wrong with an ahistorical or even antihistorical approach to God’s revelation in the pages of the New Testament. A historical approach will recognize that we must take into account that the New Testament writers operated with a concept of progressive revelation. The Old Testament could be interpreted typologically while remaining historical in orientation, such that various persons and institutions in the Old Testament were seen as pointing forward to, or being types of, Christ. This mode of interpretation is very different from the later allegorical mode of interpretation popular in the Alexandrian school that finds postcanonical and philosophical ideas in pre-Christian texts such as Song of Solomon (taken as an allegory of Christ and the church). Respecting the historical givenness of the Old Testament means that while it is possible to talk about the preexistent Christ as God’s Wisdom at work in Israel (see 1 Cor 10), this did not lead the New Testament writers to assume that they could find the Trinity under every rock in the Old Testament. I assume that the best guides to the limits of christological interpretation of the Old Testament are the New Testament writers themselves. And basically, the New Testament writers assume that there is a historical motion to the biblical story—there is a before and after, and a process that leads to a climax in Christ.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("This means that there was no full understanding of the trinitarian nature of God in the Old Testament writers; indeed, there were many things that they longed to know and understand about the future, and, as 1 Peter 1:10-12 says, God’s Spirit simply let them know that they were speaking about a later time when they spoke messianically. Hebrews 1:1-2 especially makes this sort of notion of progressive revelation clear. Revelation was partial and piecemeal in the past but has become full and reaches a climax in Christ. I assume that we should follow the New Testament writers in this direction. This in part means that the Old Testament becomes, for Christians, a book of foreshadowing, foretelling, and of types in the light of the later revelation. It does not become a textbook for any sort of full exposition of the doctrine of the Trinity, or for that matter the doctrine of the Holy Spirit, ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r49"
    }
  }), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("or for that matter even messianism. In Christian thinking the canon cannot be read flatly without regard to the progression of revelation and historical understanding of and in the text. What the Old Testament can be, however, is a source for better understanding the first person of the Trinity and the divine character, for better understanding human fallenness, for better understanding the history of God’s people and God’s efforts to redeem them, for better understanding Israelite hopes about their kings and coming kings and about their eschatological future, especially when we get to the exilic and postexilic prophetic and apocalyptic material in the Old Testament.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("Even most medieval church fathers were not totally willing to go beyond their famous Latin couplet “The New is in the Old concealed; the Old is in the New revealed.” This couplet implicitly recognized that a flat reading of the Old Testament as if it is the same sort of document as the New Testament, or even is a Christian document, is a historical mistake. One has to take into account the progressive nature of God’s revelation.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("It is worth adding here that we need to recognize that much of the use of the Old Testament in the New Testament is homiletical in character. This should be seen as a pastoral “use” of the text and thus not be viewed as serious exegesis of the text, for it does not change the meaning of the text, nor does it give us permission to suggest all biblical texts have a multiplicity of meanings—rather like ink blots into which we can read our own meanings. Put another way, these pastoral and homiletical uses of the Old Testament are not trying to tell us what the text meant or means so much as show us how it can be used for Christian purposes. "), _c('i', [_vm._v("They presuppose an already extant, relatively fixed sacred text accessible to their audience such that if they choose to do something creative with the text, this is seen not as supplanting, but rather only supplementing, the historical and contextual meaning of the text. ")]), _vm._v("This has nothing to do with their belief in some sort of "), _c('i', [_vm._v("sensus plenior")]), _vm._v(" (fuller sense) to the text, a later concept in any case. Rather, it reflects their belief that the text can be used and applied in various ways in their own Christian context. To give but one example, Paul, in 1 Corinthians 9:9, quotes Deuteronomy 25:4 about not muzzling oxen as they tread the grain, thus allowing them to get some personal benefit from their hard labor. He then applies this to gospel preachers like him, knowing full well that the Deuteronomy text is not "), _c('i', [_vm._v("about")]), _vm._v(" ministers of the gospel and their right to be remunerated or taken care of while doing the hard work of ministry.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-013"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r50"
    }
  }), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTAMENT")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEOLOGY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THICS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLE")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("As Jaroslav Pelikan makes perfectly clear, there never was a time when the Christian community combined the Hebrew Old Testament with the Greek New Testament to make a single book. Rather, once it had agreed upon the shape of its New Testament, it adopted a version of the Old Testament in Greek to serve as its Old Testament. This is perfectly clear from an examination of early codices such as Codex Sinaiticus. Christian biblical theology (as it was originally done when there was a book of two Testaments), involved an all-Greek canon, which of course is not at all the canonical basis of biblical theology today, which uses the Hebrew Scriptures along with the Greek New Testament.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN39",
      "id": "ap_NFIN39-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" The term "), _c('i', [_vm._v("biblical theology")]), _vm._v(" does not mean the same thing today that it would have meant when there first was a “complete” Bible, and in any case that sort of approach to Christian theology including New Testament theology threatens to undo, muffle, or produce a false harmony or blending of the discrete witness of the Hebrew Scriptures, which have their own Jewish voice, and the equally discrete New Testament Scriptures, which have a largely Jewish Christian voice.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We cannot start with biblical theology and then try to fit New Testament theology into that Procrustean bed. Nor can we start with the theology in the Hebrew Scriptures and see the New Testament books as simply a renewal or extension of that theology or those covenants mentioned in the Old Testament. Historically, this is not how the New Testament writers viewed things, nor should we. We must start with the discrete testimonies of the individual Testaments and take our cues from the New Testament writers as to how Christians should approach the Torah. This is a historical approach that sees biblical theology and biblical ethics as something that must be done "), _c('i', [_vm._v("after")]), _vm._v(" and be done on the basis of the detailed study of the theologies and ethics of the Old Testament and New Testament. New Testament theology, and for that matter New Testament ethics, as it is studied in these volumes neither involves a canonical approach nor assumes a biblical theological or ethical approach as its starting point in the normal way those adjectives (canonical/biblical) are used in discussions today. Rather, my approach is, in the first volume, to allow the various New Testament writers to have their own say on their own terms and then, in the second volume, to try to see what a synthetic view of "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r51"
    }
  }), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("the theologizing and ethicizing of the various witnesses looks like.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("It seems clear enough that the eschatological perspective shared by all the New Testament writers led them to conclude that they were living in the age of the new covenant, the final covenant between God and humankind. This eschatological perspective led them to the conclusion that former covenants were now, or were becoming, obsolete, because the better and final one had appeared (see, e.g., Gal 4; Hebrews). This did not mean that the Old Testament became irrelevant to Christian teaching or reflection (see 2 Tim 3:16). But what it did mean is that the Old Testament would now be viewed not so much on its own terms but rather in the light of the Christ event, which came after it.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("It means that the Old Testament would be used messianically and ecclesiologically in ways that would have made non-Christian early Jews uncomfortable and often unconvinced. There would be a homiletical use of the Old Testament that often was both more and other than simple historical exegesis of the Old Testament texts. Indeed, those uses fell more into the categories of application and implication than straightforward interpretation. Early Jews would see this hermeneutical move as supersessionism, while Christians would see it as completionism (to coin a term). The study of the use of the Old Testament in the New Testament reflects the struggle in early Christianity for self-definition and self-understanding in distinction from non-Christian Judaism but also in relationship with (and in some continuity with) early Judaism.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN40",
      "id": "ap_NFIN40-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Non-Christian Jews had their own, different interpretations of these same texts, and furthermore, there were various forms of early Judaism taking a variety of views on these texts. There was no monolithic early Jewish view or interpretation of such texts.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Since the first five books of the New Testament are some sort of narrative, and since there is a narrative structure to the last book of the New Testament, and since there is a narrative substructure to Pauline and Petrine and Johannine thinking in the New Testament as well as in Hebrews and other books, it follows that narrative and story become an especially important category for analyzing the New Testament. This in turn raises the question of the relationship of history, narrative, and story. What sort of stories do we have in the New Testament? Are they fractured fairy tales or are they historically substantive stories, or something in between?")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-014"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r52"
    }
  }), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTORY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TORY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTAMENT")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("In a recent book of great importance, "), _c('i', [_vm._v("Jesus and the Eyewitnesses: The Gospels as Eyewitness Testimony")]), _vm._v(", Richard Bauckham stresses that what we have in the New Testament is a synthesis of history and story, more particularly the stories told by eyewitness participants in the events. The sort of history that we are dealing with in the New Testament is oral history, later written down, and following the conventions for the telling of ancient oral history. As Bauckham also points out, for the ancients it was involvement in the pivotal events, not distance from them, that made them more likely accurate testifiers to what actually happened and what it meant. The “ancient historians knew that firsthand insider testimony gave access to truth that could not be had otherwise.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN41",
      "id": "ap_NFIN41-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" We should envision, then, the oral testimonies of the eyewitnesses coupled with the narrativizing and interpretative work of the New Testament writers."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN42",
      "id": "ap_NFIN42-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" In other words, not even the narratives in the New Testament should ever be treated as literary fictions, and certainly not as modern literary fictions or even ancient novels. That would be to make genre mistakes of the first order in analyzing the New Testament material.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As I have pointed out at length in "), _c('i', [_vm._v("What Have They Done with Jesus?")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN43",
      "id": "ap_NFIN43-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" what we have in the New Testament is the testimonies of eyewitnesses, indeed testimonies that can be traced back either directly or indirectly to the inner circle of Jesus (which included women), some eight or so figures who were the impetus for, or the authors of, what we find in the New Testament itself. In other words, we should take it seriously even when someone such as Luke, who was not an eyewitness, tells us that he has consulted the eyewitnesses and original teachers of the Word in writing his narrative. The theology and ethics in the New Testament are grounded in and founded on history and eyewitness testimony again and again. Why anyone ever thought that theology could be done for a historical religion such as Christianity without paying attention to the historical detail and eyewitness nature of the narratives is a mystery.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-015"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r53"
    }
  }), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTOLOGICAL")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDICATIVE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MPERATIVE")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("As should already be obvious, one of my major assumptions—really more of a settled conviction—is that both the theology and the ethics in and of the New Testament are christologically focused or centered. By this I mean that not only are the ethics connected to the theology such that the imperative is built on the indicative theological statements, but also both the ethics and the theology are profoundly grounded in Christ. Ethically this is so not just because we have a lot of Christ’s ethical teachings in the Sermon on the Mount and elsewhere, but also because the ethics of Paul and Peter and others are profoundly shaped by the person and example of Christ, such that we even hear about imitating Christ. Put another way, what most binds together the New Testament thought world, whether we are talking about belief or behavior, is Jesus Christ.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("To some this will seem perfectly obvious, but in fact so many different attempts to examine New Testament theology or ethics do not primarily focus on Christology, much less the teachings and example of Jesus, that sometimes it is necessary to state what may seem obvious to many. It is Christ who is the focal point and crystalizing agent of the theologizing and ethicizing that happens in the New Testament. This not only is what sets it apart from other forms of early Jewish thinking, but also is what makes it Christian in the proper sense of the term. Attempts to do New Testament theology by starting with ideas such as divine sovereignty and eternal decrees and irresistible grace and God’s self-glorification—or for that matter ideas such as prevenient grace and entire sanctification—are in fact not following the lead and emphases of the New Testament documents themselves. It is not primarily soteriology that binds the New Testament together, but rather Christology, for in some New Testament books we have little or no reflection at all on salvation, properly so called. Furthermore, the "), _c('i', [_vm._v("ordo salutis")]), _vm._v(" (order of salvation) is absent not only from significant portions of the New Testament (e.g., the Synoptic Gospels), but also from most of the Old Testament too. Those who insist otherwise are imposing later theological reflection and categories of a systematic sort (and often of a particular brand of soteriology) on the discussion.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("It is the Christological vision of the New Testament writers that caused a christological revisioning of monotheism, of ethics, of eschatology, of salvation, of hermeneutics, of Old Testament prophecy, and a host of other subjects. Let us take one example. The language of salvation in the Old Testament almost always refers to rescue, or a return to normality, or a regaining of health, which is to say, to very mundane things. It does not refer to ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r54"
    }
  }), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("salvation in the Christian spiritual sense of conversion to a new set of beliefs and behaviors. By contrast, most of the language of salvation in the New Testament at least alludes to the issue of conversion to Christ or to subsequent sanctification in him and his community.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("At the end of day, it is not helpful to arrange New Testament proof texts into preexistent systematic theology categories and then construct a New Testament theology or ethics or analyze New Testament theology or ethics on that basis. This puts the “dog” back in dogma, and that dog won’t hunt if we are talking about being fair to the focus and thrusts of the New Testament itself, which are christocentric and christological to the core.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-016"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTORICAL")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESUS")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSUS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH")]), _vm._v("? T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _c('br'), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESUS")]), _vm._v("’ T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACHING")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTAMENT")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEOLOGY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THICS")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("When my book "), _c('i', [_vm._v("The Christology of Jesus")]), _vm._v(" came out at the beginning of the 90s, a panel discussion of the book was undertaken at the Society of Biblical Literature. Some scholars saw it as humorous to talk about Jesus viewing himself in a messianic light. Nevertheless, I persisted, and the book has served as a stimulus in the discussion of Jesus’ self-understanding. One angry person came up after the panel discussion at the Society of Biblical Literature and accosted me: “You’re just a theologian, not a historian, why not just admit it? You’re not talking about the historical Jesus, you’re talking about the later Christian evaluation of Jesus.” If only history and theology were that easily separated and distinguished! But in fact theology and history were intertwined not just in the lives of Jesus’ followers but also in the life of Jesus himself. He had theological views, including theological views about himself. It does not require an intellectual or historical sleight of hand to come to this historical conclusion.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("The larger (and much debated) question of whether Jesus’ own teaching should be included in a “New Testament theology and ethics” study or volume needs a little more introduction at this point. Jesus was, of course, an observant Jew, not a Christian, even though I am convinced that one can say with confidence that he had a messianic self-understanding. If, with Wayne Meeks, we say that Christ is the question that prompts New Testament theologizing rather than the answer to all theological questions, "), _c('i', [_vm._v("and")]), _vm._v(" we assume that there are many layers of tradition to peel away in order to get back to the historical Jesus, "), _c('i', [_vm._v("and")]), _vm._v(", having done that, we arrive at a Jesus who is rather different than the New Testament writers envisioned, then the answer probably is no, at least when it comes to the actual teaching and ministry of ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r55"
    }
  }), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("Jesus.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN44",
      "id": "ap_NFIN44-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" But in fact Joachim Jeremias and some other very well-known New Testament scholars—Leonhard Goppelt, W. G. Kümmel, G. B. Caird, Peter Stuhlmacher and N. T. Wright, to name but a few—have included the teaching of Jesus in a volume on New Testament theology and/or ethics. Clearly, they did not see New Testament theology as simply a matter of the theological interpretation of the New Testament documents, which of course can be done with any of those documents. The issue for them was the theology "), _c('i', [_vm._v("within")]), _vm._v(" those New Testament documents and whether Jesus’ theological and ethical remarks and activities should be included as part of the discussion. At the heart of the discussion is whether one takes a historical and exegetical approach to this New Testament material or whether one primarily sees theology as an exercise in dealing with abstract ideas and concepts, comparing and contrasting them and stringing them together in particular ways (justification leads to sanctification, which leads to glorification).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A recent essay by Christopher Tuckett assesses afresh this question of whether the historical Jesus’ teaching and ministry belong in a discussion of New Testament theology."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN45",
      "id": "ap_NFIN45-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" He points to the work of William Wrede and Robert Morgan, the latter being indebted to the former, where a distinction is made between a historically descriptive approach of the data and a “committed” theological interpretation to the data. This is sometimes described as a history-of-religions approach versus a confessional approach to the data. Is doing a New Testament theology, then, really just a matter of a committed Christian theologian, operating from that standpoint, offering an interpretation of the New Testament data? If that is what it is, then of course it is an in-house matter, and non-Christian interpreters need not apply for the job of interpreting the New Testament in this way.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I must say that this claim bothers me as a historian. Of course, every interpreter of the New Testament has a point of view, and that point of view needs to be taken account of, but I do not think that we should assume that non-Christian scholars or others are incapable of assessing even the theological data within the New Testament and doing it accurately. I do not think that we "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r56"
    }
  }), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("should assume, for example, that a scholar such as Professor Amy-Jill Levine, my colleague in New Testament studies at Vanderbilt, who is an observant Jew, is incapable of producing a fine volume on New Testament theology. And this is because it is not primarily a matter of her point of view; rather, it is primarily about critically and correctly assessing the theological or ethical evidence within the New Testament. You do not have to be a Christian to do that. So, I must reject the definition that suggests that doing or studying or writing about New Testament theology is a task only for a committed Christian theologian. Just as I do not see the historical Jesus as a threat or a problem for New Testament theology, likewise I do not see non-Christian scholars as a threat or a problem if they seek to understand and write about the New Testament theological and ethical data. In fact, we have much to learn from them.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("Of course, one of the real problems with excluding the words, deeds and ministry of Jesus from a discussion of New Testament theology and ethics is that the New Testament writers themselves sometimes quote and often allude to Jesus’ own teachings and often see the life pattern of the historical Jesus as a paradigm for Christians to follow. And how, exactly, are we to conceive of the function of the four canonical Gospels if they were not intended to teach Christians how to think theologically and ethically as at least part of their function? Apparently, the evangelists assumed that Jesus’ life and teachings were fundamental resources for Christian theologizing and ethicizing in their communities.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("Tuckett wants to make the very limited claim that the voice and teachings and life of Jesus belong as part of the conversation about New Testament theology and ethics, and that the historical Jesus and his ministry and teaching can act as something of a norm as we seek to make theological value judgments about the New Testament data. The strong limits of his claim can be seen in the following quotation:")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant last"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("One cannot equate Christology with Jesus’ own teaching; one cannot substitute the historically reconstructed Jesus for Christian claims about Jesus. Indeed, it can be argued that, in some respects, a Jesus who is too continuous with later Christian theology could in fact be no longer suitable as the focus figure for that theology. A Jesus who had already formulated some ideas about the positive meaning of the cross, who knew already prior to his death that that death would surely be reversed by “resurrection” and who perhaps claimed a uniqueness over and beyond that of any “normal” mortal, would be a Jesus for whom the agony of Gethsemane and the cry of dereliction on the ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r57"
    }
  }), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("cross would be a sham; it would be a Jesus whom no Christian could claim plumbed the deepest depths if human despair and godlessness . . . and who could then be the agent who brought about “reconciliation” or “redemption” . . . in the most profound sense claimed by Christian theology.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN46",
      "id": "ap_NFIN46-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("My response to this assessment is mixed. Tuckett is right that we cannot simply equate the messianic thinking and expression of Jesus about himself with the later full-orbed Christology of the New Testament writers; however, we do need to think that the former prepared for and provided some of the substance for the latter. In other words, we must think of a developing continuum, not a dichotomy as if the Easter event somehow cut followers off from the historical Jesus and his teachings and ministry. To say that these things manifest some continuity is not to suggest that we could simply equate the teaching of the historical Jesus with the later teaching about Jesus in some sort of identity statement.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Of course, it is true that later rumination on Jesus led to insights and understanding of truths about Jesus that in various cases he himself never spoke to or of during his ministry. For example, Jesus never says anything directly about the virginal conception, though he does insist at numerous junctures that the heavenly Father is his father. Or again, the historical Jesus never says, “One must confess that Jesus Christ is the risen Lord, and by this means you can be saved.” There are, of course, aspects of later theologizing about Jesus that find no analogue in the things that we know the historical Jesus actually said. However, I strongly disagree with Tuckett’s view in regard to whether Jesus made some positive remarks about the cross and about vindication beyond death in advance of his death. It is very likely that he did do this, and this is not a surprise, because before him some of the Maccabean martyrs also said remarkable things about the atoning merit of their coming deaths and how God would at least vindicate their cause (and, presumably, themselves at the last resurrection). Recent revelations about the so-called Gabriel Stone suggest there may have been some ruminations, even before the time of Jesus about a dying and rising Jewish messiah, but the text says nothing about crucifixion, and unfortunately some words are missing at the critical juncture or are too difficult to decipher. Still, it may show that Jesus’ passion predictions could be authentic and a genuine part of early Jewish discussion about messiah."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN47",
      "id": "ap_NFIN47-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I would also suggest that the historical Jesus, while remaining fully hu"), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r58"
    }
  }), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("man, absolutely did claim some sort of uniqueness that placed him in a category well beyond an average or ordinary or normal mortal. Indeed, it is likely that this is one of the things that got him killed—a result of what he said before Pilate and probably before the Sanhedrin too. I will say more about this in the next chapter. Here it must suffice to say this: the historical Jesus and his teaching must be seen as part of the proper subject matter of a study of New Testament theology and ethics, and not just because it is the stimulus for later post-Easter Christian thought and expression. At the same time, one must view these matters from a historical point of view recognizing similarity, and also development and difference, between the ways Jesus expressed himself and the ways later Christians spoke about him. My point is simply that a proper way to view this is as a matter of addition, not subtraction, and certainly not substitution such that the Christ of faith replaces the historical Jesus. Later New Testament christological reflection about Jesus went beyond what he said and did, but it did not go against it, nor did it distort the cut and thrust of what Jesus said and how he presented himself.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("In a recent study entitled "), _c('i', [_vm._v("Christ Is the Question")]), _vm._v(", Wayne Meeks makes the following perceptive observation: “The way the Bible is used in theology depends on the way the reader construes the Bible—that is, what one takes the Bible essentially to be.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN48",
      "id": "ap_NFIN48-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" This is exactly right. The Bible is not the tale of the evolution of abstract ideas such as “atonement” or “the Trinity.” It is, instead, a disparate collection of various sorts and genres of documents whose aims are historical, theological, and ethical (not to mention cultic or religious), whose meaning is affected or determined by the genres of its material, and whose function is constantly related to a living faith community with an ongoing historical existence, including a community that has experienced what can be called “salvation history” and as a result has told their stories about this life and these events in the form of various narratives. Not by any means is all the Bible narrative in its literary form, but all the Bible, even its rules and laws, are related to theological concepts such as covenant and thereby to larger narratives about the interactions between God and his people and indeed with the world.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-017"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTELLECT")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MAGINATION")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN")]), _c('br'), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTAMENT")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEOLOGY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THICS")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Sometimes I am asked if it requires the sacrifice of the intellect to believe what the Bible says about some subject or another. My response is that one "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r59"
    }
  }), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("does not need to have a frontal lobotomy either to believe what the New Testament says or to attempt to practice what it calls us to do. In fact, it requires not the sacrifice of the intellect but rather the sanctification of the intellect, the renewal of the mind discussed in Romans 12:1-2, if one is to understand, much less apply, this material. One needs to use the full extent of one’s intellectual capacity to grasp some of this material. Spiritual things are spiritually understood, especially when one is talking about some of the more profound aspects of theology or ethics found in the New Testament. One thing that I am sure of as we begin this foray through the New Testament witnesses to look at theologizing and ethicizing: Jesus himself made an indelible impression on his followers. I believe that we will understand the New Testament to the extent that we understand Jesus, and vice versa. These two things are inevitably and inextricably intertwined, as are history and theology and ethics. We should not be surprised at this fact. If God indeed incarnated himself in the person of Jesus, then obviously theology and history have become one in a very real and personal sense. We must keep all these things in mind as we begin our theological and ethical pilgrimage through the New Testament.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("In order to make this volume as readable as possible and take the “stuffings” out of usually stuffy theological and ethical discussions, I have kept the footnotes to a minimum, and I have eschewed using a lot of technical jargon, though some is unavoidable. Since this work is based on my commentaries, the reader who wants lots more references and bibliography and esoterica can turn to those commentaries for the details. These volumes are based on my previous twenty-five years of doing exegesis of the New Testament; they do not simply repeat what is in those volumes, though a good deal of overlap is inevitable because in assessing and presenting the theology and ethics of the New Testament witnesses, we are dealing with exegetical issues.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("One last thing. You need to use your imagination while reading this volume. So consider the following before you turn to the first full chapter. Think for a minute of the image of a small choir rehearsing for a big performance of a masterwork. Each singer must know her or his own individual part well, and each one must also be able to sing in tune and in harmony with the other singers. One of the reasons to be especially diligent is because the creator of this music is going to perform with the choir as the chief soloist on this night. And of course the whole choir is excited and wants to please the composer turned performer. This is all the more so since the piece in question is the musical biography of the soloist himself—the most famous soloist ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r60"
    }
  }), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("in the world. They will do their best to represent the soloist well and blend in with his interpretation of his own music. They want him to be the dominant voice, and they are present to help highlight his voice and music.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("This little allegory encapsulates how I view both the New Testament witnesses and the relationship of Jesus to them. In this volume of this study we will only be hearing each of the individual “singers” rehearse individual parts in the larger masterwork that we call “New Testament theology and ethics.” There are a nice variety of individual voices, but already here at the outset we get to hear from the composer himself, the one who inspired all these other voices to sing in their various ways. His voice is the dominant voice, and others will be playing off that voice and trying to harmonize with it. It is thus incumbent on us to let the soloist get in the first word—after all, the score is his, and the libretto is about him as well! So in our first full chapter we must turn to Jesus himself.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-018"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OR")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URTHER")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EADING")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("At the end of chapters I provide a short list of good bibliography, usually on the subject just discussed. Here, however, I offer an introductory list of useful survey texts on New Testament theology and ethics. These lists are intended to be representative and highly selective, highlighting certain useful or influential volumes.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-001"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("New Testament Theology")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("Bultmann, Rudolf. "), _c('i', [_vm._v("Theology of the New Testament")]), _vm._v(". Translated by Kendrick Grobel. 2 vols. in 1. New York: Scribner, 1955.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("Caird, G. B. "), _c('i', [_vm._v("New Testament Theology")]), _vm._v(". Edited by L. D. Hurst. Oxford: Clarendon Press, 1994.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("Goppelt, Leonhard. "), _c('i', [_vm._v("Theology of the New Testament")]), _vm._v(". 2 vols. Grand Rapids: Eerdmans, 1981-1982.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("Hurtado, Larry W. "), _c('i', [_vm._v("Lord Jesus Christ: Devotion to Jesus in Earliest Christianity. ")]), _vm._v("Grand Rapids: Eerdmans, 2003.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("Jeremias, Joachim. "), _c('i', [_vm._v("New Testament Theology: The Proclamation of Jesus")]), _vm._v(". Translated by John Bowden. New York: Scribner, 1971.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("Ladd, George Eldon, and Donald A. Hagner. "), _c('i', [_vm._v("A Theology of the New Testament. ")]), _vm._v("2nd ed. Supplemented by Donald A. Hagner. Grand Rapids: Eerdmans, 1993.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("Marshall, I. Howard. "), _c('i', [_vm._v("New Testament Theology: Many Witnesses, One Gospel")]), _vm._v(". Downers Grove, Ill.: InterVarsity Press, 2004.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r61"
    }
  }), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Matera, Frank J. "), _c('i', [_vm._v("New Testament Theology: Exploring Diversity and Unity")]), _vm._v(". Louis-ville: Westminster John Knox, 2007.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Schneider, Sandra M. "), _c('i', [_vm._v("The Revelatory Text: Interpreting the New Testament as Sacred Scripture.")]), _vm._v(" 2nd ed. Collegeville, Minn.: Liturgical Press, 1999.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Schreiner, Thomas R. "), _c('i', [_vm._v("New Testament Theology: Magnifying God in Christ")]), _vm._v(". Grand Rapids: Baker Academic, 2008.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Thielman, Frank. "), _c('i', [_vm._v("Theology of the New Testament: A Canonical and Synthetic Approach. ")]), _vm._v("Grand Rapids: Zondervan, 2005.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Watson, Francis B. "), _c('i', [_vm._v("Text and Truth: Redefining Biblical Theology. ")]), _vm._v("Edinburgh: T & T Clark, 1997.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Witherington, Ben, III, and Laura M. Ice. "), _c('i', [_vm._v("The Shadow of the Almighty: Father, Son and Spirit in Biblical Perspective.")]), _vm._v(" Grand Rapids: Eerdmans, 2002.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-002"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("New Testament Ethics")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Brawley, Robert L., ed. "), _c('i', [_vm._v("Character Ethics and the New Testament: Moral Dimensions of Scripture. ")]), _vm._v("Louisville: Westminster John Knox, 2007.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Brower, Kent E., and Andy Johnson, eds. "), _c('i', [_vm._v("Holiness and Ecclesiology in the New Testament")]), _vm._v(". Grand Rapids: Eerdmans, 2007.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Burridge, Richard A. "), _c('i', [_vm._v("Imitating Jesus: An Inclusive Approach to New Testament Ethics. ")]), _vm._v("Grand Rapids: Eerdmans, 2007.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Collins, Raymond F. "), _c('i', [_vm._v("Christian Morality: Biblical Foundations. ")]), _vm._v("Notre Dame, Ind.: University of Notre Dame Press, 1986.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Furnish, Victor P. "), _c('i', [_vm._v("The Love Command in the New Testament. ")]), _vm._v("Nashville: Abingdon, 1972.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Hays, Richard B. "), _c('i', [_vm._v("The Moral Vision of the New Testament: Community, Cross, New Creation. ")]), _vm._v("San Francisco: HarperSanFrancisco, 1996.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Meeks, Wayne A. "), _c('i', [_vm._v("The Origins of Christian Morality")]), _vm._v(". New Haven: Yale University Press, 1993.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Schnackenburg, Rudolf. "), _c('i', [_vm._v("The Moral Teaching of the New Testament. ")]), _vm._v("Translated by J. Holland-Smith and W. J. O’Hara. New York: Herder & Herder, 1965.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Schrage, Wolfgang. "), _c('i', [_vm._v("The Ethics of the New Testament. ")]), _vm._v("Translated by David E. Green. Minneapolis: Fortress, 1988.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Verhey, Allen. "), _c('i', [_vm._v("The Great Reversal: Ethics and the New Testament. ")]), _vm._v("Grand Rapids: Eerdmans, 1984.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Wells, Samuel. "), _c('i', [_vm._v("Improvisation: The Drama of Christian Ethics. ")]), _vm._v("Grand Rapids: Brazos Press, 2004.")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30fb2ae4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre5.vue
// module id = 78
// module chunks = 0